import { useState } from 'react';

const useLoading = (initialState = false) => {
    const [isLoading, setIsLoading] = useState(initialState);

    const startLoading = () => setIsLoading(true);
    const stopLoading = () => setIsLoading(false);
    const toggleLoading = () => setIsLoading(prev => !prev);

    const withLoading = async (asyncFunction) => {
        try {
            startLoading();
            const result = await asyncFunction();
            return result;
        } catch (error) {
            throw error;
        } finally {
            stopLoading();
        }
    };

    return {
        isLoading,
        startLoading,
        stopLoading,
        toggleLoading,
        withLoading
    };
};

export default useLoading;
